<h2 matDialogTitle>{{data.title}}</h2>
<mat-dialog-content class="respect-linebreaks">{{data.content}}</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button matDialogClose>{{data.buttonLabel}}</button>
</mat-dialog-actions>



// WEBPACK FOOTER //
// ./node_modules/@cicero/webui/lib/core/dialogs/alert-dialog/alert-dialog.component.html